import React, { useContext } from "react";
import { IonItem, IonLabel, IonButton } from "@ionic/react";
import { AppConfigContext } from "../../context/AppConfigContext";
import { ProyectosContext } from "../../context/ProyectosContext";
import { PartidasContext } from "../../context/PartidasContext";
import AvancePickerMobile from "./AvancePickerMobile";
import ConceptoProgressBar from "../global/ConceptoProgressBar";
import { getValue } from "../../utils";
import {
  renderNombrePartida,
  partidaTieneAditivos,
} from "../../utils/partidas";
import { DestajosContext } from "../../context/DestajosContext";
import { SubdestajosContext } from "../../context/SubdestajosContext";

const PartidaMobile = ({
  partida,
  collapsed,
  setPartida,
  getProyecto,
  toggleDestajos,
  hasChildren,
}) => {
  const appconfig = useContext(AppConfigContext);
  const { proyecto } = useContext(ProyectosContext);
  const { postAvancePartida } = useContext(PartidasContext);
  const { destajos } = useContext(DestajosContext);
  const { subdestajos } = useContext(SubdestajosContext);

  const { idProyecto, permiso, idPermiso } = proyecto || {};

  console.log("PartidaMobile permiso:", permiso, "idPermiso:", idPermiso);

  const canEditProgress = () =>
    ["admin", "supervisor", "contratista"].includes(permiso) ||
    [3, 6].includes(parseInt(idPermiso));

  const avanceMode = proyecto?.modo_avance || "destajo";

  // Partida-level avance (programado + picker) when the project tracks by partida;
  // otherwise the partida is read-only and shows the real-vs-programado bar.
  const showBottomRow = avanceMode === "partida";
  const showBar = avanceMode === "destajo";

  const showPicker =
    showBottomRow &&
    getValue(appconfig, "progress") !== "money" &&
    canEditProgress();

  const postAvance = (cont, isManual) => {
    postAvancePartida(
      partida.idPartida,
      cont,
      idProyecto,
      getProyecto,
      isManual,
    );
  };

  const generalPartida = parseFloat(partida.generalPartida);
  const realPct = Math.round((parseFloat(partida.real) || 0) * 100);
  const pickerValue = realPct;
    /*!isNaN(generalPartida) && generalPartida > 0
      ? Math.round(generalPartida)
      : realPct;*/

  const programado =
    partida.programado !== null && !isNaN(parseFloat(partida.programado))
      ? `${parseInt(parseFloat(partida.programado) * 100)}%`
      : "-";

  // Progress bar (real vs programado) — mirrors ProgresoPartidaChart.
  const barRealPct =
    getValue(appconfig, "progress") === "money"
      ? parseInt(partida.progreso)
      : parseInt(partida.real * 100);
  const programadoPct = parseInt(Number(partida.programado) * 100);
  const diff = programadoPct - barRealPct;
  let programadoClass = "programado-gradiente";
  if (diff > 10) programadoClass = "diferencial-gradiente";
  else if (diff >= 5) programadoClass = "pagos-gradiente";

  return (
    <IonItem
      key={partida.idPartida}
      className="px-0"
      style={{
        // Aditiva: avance over 100%, highlighted like aditivo conceptos.
        ...(partidaTieneAditivos(partida, destajos, subdestajos) && {
          "--background": "#fffaea",
        }),
        "--background-focused": "transparent",
        "--background-activated": "transparent",
        "--background-hover": "transparent",
        "--ripple-color": "transparent",
      }}
    >
      <IonLabel className="ion-text-wrap">
        <div className="d-flex align-items-center">
          {hasChildren && (
            <IonButton
              fill="solid"
              color="light"
              style={{
                color: "white",
                width: "15px",
                height: "25px",
                marginRight: "10px",
              }}
              onClick={() => toggleDestajos(partida.idPartida)}
            >
              <i className={`fa fa-chevron-${collapsed ? "down" : "up"}`}></i>
            </IonButton>
          )}
          <span className="ps-2 bold flex-grow-1">
            {renderNombrePartida(partida)}
          </span>
          <IonButton
            fill="solid"
            color="light"
            style={{
              color: "#b76d4f",
            }}
            onClick={() => setPartida(partida)}
          >
            <i className="fa fa-info"></i>
          </IonButton>
        </div>
        {showBar && (
          <div className="mt-2">
            <ConceptoProgressBar
              idPartida={partida.idPartida}
              programado={programadoPct}
              real={barRealPct}
              handleClick={() => setPartida(partida)}
              programadoClass={programadoClass}
              height={16}
              showLabels
            />
          </div>
        )}
        {showBottomRow && (
          <div className="d-flex align-items-center justify-content-between mt-2 w-100">
            <div>
              <div className="bold">{programado}</div>
              <div
                className="text-muted"
                style={{ fontSize: "0.55rem", lineHeight: 1 }}
              >
                programado
              </div>
            </div>
            {showPicker ? (
              <div style={{ width: "60%" }}>
                <AvancePickerMobile
                  permitirExcedente
                  progreso={pickerValue}
                  setCantidad={postAvance}
                  intervalo={1}
                  limite={100}
                />
              </div>
            ) : (
              <>{pickerValue}%</>
            )}
          </div>
        )}
      </IonLabel>
    </IonItem>
  );
};

export default PartidaMobile;
